<template>
  <div class="container">
    <v-content>
      <stamped-io-feed :show-at-page="true" />
    </v-content>
  </div>
</template>

<script>
import VContent from '~/components/shared/v-content/VContent'
import StampedIoFeed from '~/components/pages/stampedio-feed/StampedIoFeed.vue'

export default {
  name: 'Shopinsta',
  components: {
    VContent,
    StampedIoFeed,
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/container.scss';
</style>
